import gsap from "gsap";
import { getIsMobile } from "../helpers/getIsMobile";
import { html } from "../helpers/stringHTML";

const DEFAULT_DURATION = 0.3;

const applyStyles = (el, styles) => {
    if (!el) return;
    Object.assign(el.style, styles);
};

export const crossCloserHandler = (toggler, { duration = DEFAULT_DURATION, instant = false } = {}) => {
    if (!toggler) return;

    const sideMenu = document.querySelector(".wrap_side_menu");
    const isClosed = sideMenu.classList.contains("close");
    const willOpen = isClosed;

    toggler.classList.toggle("close", !willOpen);
    sideMenu.classList.toggle("close", !willOpen);

    const crossSVG = html`
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17 17L1 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17 1L1 17"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    `;

    const burgerSVG = html`
        <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5 19H15.7857M1.5 10H26.5M12.2143 1H26.5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    `;

    const innerHTML = willOpen ? crossSVG : burgerSVG;

    toggler.innerHTML = innerHTML;

    const isMobile = getIsMobile();

    const container3D = document.querySelector(".d3d-container");
    const footer = document.querySelector("footer");
    const targetWidth = willOpen ? "calc(100% - 570rem)" : "100%";
    const targetBottomDesctop = willOpen ? "0" : "-85rem";
    const targetBottomMobile = willOpen ? "-85rem" : "0";
    const targetBottom = isMobile ? targetBottomMobile : targetBottomDesctop;
    const addInRoomBtnWrap = document.querySelector(".add_in_room_btn_wrap");
    const animateDoorsBtnWrap = document.querySelector(".animate-doors_btn_wrap");
    const assistBtns = document.querySelector(".assist_btns");
    const backgroundBlack = document.querySelector(".menu-background");

    backgroundBlack.classList.toggle("visible", willOpen);

    const elementsWithWidth = [container3D, animateDoorsBtnWrap, addInRoomBtnWrap, assistBtns];

    if (instant) {
        elementsWithWidth.forEach((el) => applyStyles(el, { width: targetWidth }));
        applyStyles(footer, { bottom: targetBottom });
    } else {
        elementsWithWidth.filter(Boolean).forEach((el) => {
            gsap.to(el, {
                width: targetWidth,
                duration,
                ease: "power2.inOut",
            });
        });

        gsap.to(footer, {
            bottom: targetBottom,
            duration,
            ease: "power2.inOut",
        });
    }
};
